import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CadastroContato } from '../interfaces/cadastro-contato';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CadastroContatoService {

  readonly path = '/cadastro/contato';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cadastro: CadastroContato): Observable<CadastroContato> {
    return this.http.put<CadastroContato>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getContato(id: number ): Observable<CadastroContato> {
    return this.http.get<CadastroContato>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getContatoPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<CadastroContato>> {
    return this.http.get<PageResult<CadastroContato>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getContatoPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<CadastroContato>> {
    return this.http.get<PageResult<CadastroContato>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
